import dayjs from 'dayjs';

import { CompanyStates } from '~types/company';

export const getCompanyYear = (year: number, companyStates?: CompanyStates) => {
  if (companyStates?.closed) {
    return `${year} ~ ${dayjs(companyStates.closedAt).format('YYYY')}`;
  }

  return year;
};
